import React from 'react';

import { formatAsPrice } from '../../Helpers/String';
import { Color } from '../../Enum/Color';

interface Props {
    price: string | null;
    color?: Color | null;
}

const FormattedPrice: React.FC<Props> = ({ price, color = null }: Props) => {
    const formattedPrice = formatAsPrice(price);
    if (formattedPrice === null) {
        return <>n.b.</>;
    }

    if (color === undefined || color === null) {
        return <>{formattedPrice}</>;
    }

    return <span className={color.toLowerCase()}>{formattedPrice}</span>;
};

export default FormattedPrice;
